import React from 'react'
//CSS
import styles from './Routes.module.css';

const Resources = () => {
  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <h1>Resources</h1>
      </div>
      <div className={styles.body}>

      </div>
    </div>
  )
}

export default Resources